export type IEmployee = {
  _id?: string;
  name: string;
  email: string;
  companyId: string;
  type: string;
  position: string;
  active: boolean;
  viewAll: boolean;
};

export type ConsultantOption = {
  value: string;
  label: string;
};

export const emptyEmployee = {
  _id: "",
  name: "",
  email: "",
  companyId: "",
  type: "",
  position: "",
  active: false,
  viewAll: false,
};

export enum TYPE_EMPLOYEE {
  OPERADOR = "Operador",
  MECHANIC = "Mecânico",
  MANAGER = "Gerente",
  CONSULTANT = "Consultor",
  SDR = "SDR",
}
